import { HOST } from "../constants/HostConstants";

export const advertisementApprove = async (advertisement_id) => {
  try {
    const response = await fetch(
      `${HOST}/api/advertisement/advertisementApprove`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          advertisement_id,
        }),
      },
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Failed to approve advertisement");
    }

    return await response.json();
  } catch (error) {
    console.error("Error approving ad:", error);
    throw error;
  }
};
